import React, { createRef, Fragment, useEffect, useState } from "react"
import { useDispatch } from "react-redux";
import { closeMobileNavigation } from "../Actions/Navigation.action";
import { translate } from "../Services/translation";
import SideMenu from "./SideMenu";

const NavigationMobile = ({ mobileOpen, contentLinks, channelPickerItems, startPageUrl, mobileHeaderTitle, mobileHeaderTitleUrl }) => {
    
    const [currentLink, setCurrentLink] = useState()
    const dispatch = useDispatch()
    const showChildLinks = (e, link) => {
        e.preventDefault()
        var linkCopy = link
        if (currentLink)
            linkCopy.parent = currentLink
        setCurrentLink(linkCopy)
    }

    const goToParentLink = () => {
        if (currentLink && currentLink.parent)
            setCurrentLink(currentLink.parent)
        else
            setCurrentLink(undefined)
    }

    const headerComponent = currentLink
        ? <div className="side-menu__header-text">
            <span className="side-menu__back-button" onClick={goToParentLink}>
                <i className="far fa-chevron-left"></i>
                {currentLink.name}
            </span>
        </div>
        : <>
            {mobileHeaderTitle && <a href={mobileHeaderTitleUrl} className="side-menu__header-cta">{mobileHeaderTitle}</a>}
            {!mobileHeaderTitle && <a href={startPageUrl} className="side-menu__header-logo"><img src={window.__litium.logoUrl} /></a>}
        </>


    const hasChildren = link => link.links && link.links.length > 0

    const links = currentLink ? currentLink.links : contentLinks


    return <SideMenu id="MobileNavigation" header={headerComponent} open={mobileOpen} onClosed={() => dispatch(closeMobileNavigation())} from="left" duration="0.25s">
        {(!currentLink || !currentLink.isCustomMegaMenu) && links.map(link =>
            <li key={link.name + link.url} className="side-menu__link">
                <a href={link.url}
                    onClick={e => !link.url && hasChildren(link) && showChildLinks(e, link)}
                    style={{
                        flexGrow: !hasChildren(link) ? 1 : null,
                        color: link.nameColor,
                        fontWeight: link.nameBold ? 600 : null
                    }}>
                    {link.name}
                    {link.tagValue && <span className={"link-tag link-tag--" + link.tagValue}>{link.tagName}</span>}
                </a>
                {hasChildren(link) && <div className="side-menu__child-link" onClick={e => hasChildren(link) && showChildLinks(e, link)}>
                    <i className="far fa-chevron-right"></i>
                </div>}
            </li>
        )}
        {channelPickerItems && channelPickerItems.map((channelItem) => (
            <li className="side-menu__link side-menu__channel--item"><a href={channelItem.url}>{channelItem.displayName}</a></li>
        ))}
        
        {currentLink && currentLink.isCustomMegaMenu && currentLink.links.map((section, idx) => <Fragment key={section.name + section.url + idx}>
            <div className="side-menu__section-header" style={{ color: section.nameColor, fontWeight: section.nameBold ? 600 : null }}>{section.name}</div>
            <ul>
                {section.links.map((link, idx) => <Fragment key={link.name + link.url + idx}>
                    <li className="side-menu__link">
                        <a href={link.url} style={{ flexGrow: 1, fontWeight: link.nameBold ? 600 : null }}>
                            {link.name}
                            {link.tagValue && <span className={"link-tag link-tag--" + link.tagValue}>{link.tagName}</span>}
                        </a>
                    </li>
                </Fragment>)}
            </ul>
        </Fragment>)}
    </SideMenu>
}

export default NavigationMobile